import React from 'react'
import ColorCheckItemPage from './ColorCheckItemPage'
import '../styles/index.scss'

const ColorCheckItemContainer = () => {
    return (
        <div className='ColorCheckItemContainer'>
            <ColorCheckItemPage />
        </div>
    )
}

export default ColorCheckItemContainer